import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { FormElementContainer } from "core/Form";
import { StyledCheckMark } from "core/FormInput/styles";
import {
    StripeFormInputContainer,
    InputWrapper,
    SuccessIconWrapper
} from "./styles";

let StripeFormInput = ({
    children,
    label,
    validation,
    value,
    handleFormChange,
    /* for applying different error state
    styling to Stripe elements */
    forStripeElement,
    className
}) => {
    const [hovered, setHovered] = useState(false);
    const [focused, setFocused] = useState(false);
    const [complete, setComplete] = useState(false);
    const [error, setError] = useState(undefined);

    const validateInput = () => {
        for (const rule of validation) {
            if (!rule.isValid(value)) {
                setComplete(false);
                setError(rule.errorMsg);
                return;
            }
        }

        setComplete(true);
    };

    const handleStripeFocus = () => {
        setFocused(true);
    };

    const handleStripeBlur = () => {
        setFocused(false);
        if (validation) validateInput();
    };

    const handleStripeOnChange = e => {
        e.target && handleFormChange(e.target.value);

        e.error ? setError(e.error.message) : setError(undefined);
    };

    const handleStripeOnMouseEnter = () => setHovered(true);

    const handleStripeOnMouseLeave = () => setHovered(false);

    return (
        <StripeFormInputContainer>
            <FormElementContainer
                className={className}
                width="100%"
                placeholderText={label}
                labelText={label}
                hideLabel={!focused}
                hideErrorMessage={focused}
                errorMessage={error}
            >
                <InputWrapper size="md">
                    {React.cloneElement(children, {
                        className: complete ? "input-complete" : "",
                        value,
                        onFocus: handleStripeFocus,
                        onBlur: handleStripeBlur,
                        onChange: handleStripeOnChange,
                        placeholder: label,
                        onMouseEnter: handleStripeOnMouseEnter,
                        onMouseLeave: handleStripeOnMouseLeave
                    })}

                    <SuccessIconWrapper>
                        <StyledCheckMark />
                    </SuccessIconWrapper>
                </InputWrapper>
            </FormElementContainer>
        </StripeFormInputContainer>
    );
};

StripeFormInput.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    handleFormChange: PropTypes.func,
    validation: PropTypes.shape({
        isValid: PropTypes.bool,
        errorMsg: PropTypes.string
    }),
    forStripeElement: PropTypes.bool,
    className: PropTypes.string
};

StripeFormInput = styled(StripeFormInput)``;

export default StripeFormInput;
